import EToastContructor from './index.vue'
import { createVNode, isVNode, render } from 'vue'

let seed = 1


// 实例初始化 , container
const initInstance = function(options){
  const vnode = createVNode(
    EToastContructor,
    options,
    isVNode(options.txt) ? { default: () => options.txt } : null
  )
  return vnode
}
const getInstance = ((fn)=>{
  var instance;
  return (options, container, oldContainer,isRecovery = false)=>{
    if(isRecovery){
      return (instance = null)
    }
    if(instance){
      var keys = Object.keys(options)
      for(let key of keys){
        instance.props[key] = options[key]
      }
      if(oldContainer)render(null, oldContainer)
    }
    return instance || (instance = fn.apply(this,[options, container]))
  }
})(initInstance)




let oldContainer = null

const EToast = function(opts = {}){
  if(typeof window === 'undefined')return
  const id = 'toast' + seed++
  let options = {
    ...opts,
    id
  }
  let container = document.createElement('div')
  container.className = `container_toast_${id}`
  let vm = getInstance(options, container, oldContainer)
  oldContainer = container
  render(vm, container)
  document.body.appendChild(container.firstElementChild)
  // clean message element preventing mem leak
  vm.props.onDestroy = () => {
    console.log('onDestroy---', container ,vm.component.props.id)
    render(null, container)
    // since the element is destroy, then the VNode should be collected by GC as well
    // we do not want cause any mem leak because we have returned vm as a reference to users
    // so that we manually set it to false.
  }
  vm.props.onTimeout = ()=>{
    typeof opts.onTimeout === 'function' && opts.onTimeout()
  }
  return {
    show: ()=> vm.component.proxy.show(),
    close: ()=> vm.component.proxy.isVisible = false
  }
}

export function closeAll(tvm){
  tvm?.close()
  getInstance(null, null, null, true)
  oldContainer = null
}

EToast.closeAll = closeAll

EToast.install = (app)=>{
  app.config.globalProperties.$toast = EToast
}
export default EToast